/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { AllowanceModule__factory } from "./AllowanceModule__factory";
